// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"basic-menu-item_menuItem__3dNdS","menuItemInner":"basic-menu-item_menuItemInner__uNnyC"};